import type { MultiPolygon, Polygon } from 'geojson';
import L from 'leaflet';

interface StripedPolygonOptions {
    stripeOptions?: L.StripePatternOptions;
    polygonOptions?: L.PolylineOptions;
}

const defaultOptions: StripedPolygonOptions = {
    stripeOptions: {
        color: 'var(--cc-map-extended-region-area-stripe)',
        weight: 5,
        angle: 135,
        opacity: 0.5,
        width: 12,
        height: 12,
    },
    polygonOptions: {
        stroke: true,
        color: 'var(--cc-map-extended-region-area-stroke)',
        weight: 1,
        opacity: 0.1,
    },
};

export const stripedPolygon = function (area: Polygon | MultiPolygon, options?: StripedPolygonOptions): L.Polygon {
    if (!area) {
        return L.polygon([]);
    }

    const stripeOptions = { ...defaultOptions.stripeOptions, ...options?.stripeOptions };
    const stripePattern = L.stripePattern(stripeOptions);

    const polygonOptions = { ...defaultOptions.polygonOptions, fillPattern: stripePattern, ...options?.polygonOptions };
    const latLngs = L.GeoJSON.coordsToLatLngs(area.coordinates, area.type === 'Polygon' ? 1 : 2);
    const polygon = L.polygon(latLngs, polygonOptions);
    polygon.onAdd = function (map) {
        stripePattern.addTo(map);
        return L.Polyline.prototype.onAdd.call(this, map);
    };
    polygon.onRemove = function (map) {
        stripePattern.remove();
        return L.Polyline.prototype.onRemove.call(this, map);
    };

    return polygon;
};
